import {
  Flex,
  HStack,
  Box,
  chakra,
  Avatar,
  WrapItem,
  Table,
  Text,
  Tr,
  Td,
  TableContainer,
  VStack,
  useDisclosure,
  Heading,
  Image,
  Spinner,
  Icon,
  Button,
  Drawer,
  DrawerOverlay,
  DrawerContent,
  DrawerBody,
  DrawerHeader,
  DrawerCloseButton,
  Skeleton,
  SkeletonText,
  Input,
  InputGroup,
  InputLeftElement,
  Badge,
  Divider,
} from '@chakra-ui/react';
import { StarIcon } from '@chakra-ui/icons';
import React, { useContext, useState, useEffect, useMemo } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { SearchContext } from './SearchContext';
import Loading from '../../Loading';
import '../css/lista-medicos.css';
import DotsLoading from '../../Utils/Components/DotsLoading';
import { AccountContext } from '../../AccountContext';
import haversine from 'haversine-distance';
import { SiGooglemaps } from 'react-icons/si';
import BottomNavBar from 'components/BottomNavBar';
import AvisoSemMedicos from './Telemedicina/MedicoAgora/Modal/AvisoSemMedicos';
import Searchbox from './Searchbox';
import VishMedicos from '../../../images/VishMedicos.svg';
import { userIsSubscriber } from 'components/Utils/theme';
import { IoIosAlert, IoMdCalendar } from 'react-icons/io';
import { RiMapPin2Fill } from 'react-icons/ri';
import { FiSearch, FiCheck } from 'react-icons/fi';
import empresa from '../../../images/dashboard/empresa.svg';

function getRandomInt(min, max) {
  min = Math.ceil(min);
  max = Math.floor(max);
  return Math.floor(Math.random() * (max - min) + min);
}

const ENDPOINT =
  process.env.REACT_APP_ENVIRONMENT === 'production'
    ? process.env.REACT_APP_BASE_URL_API_SERVER_PROD
    : process.env.REACT_APP_BASE_URL_API_SERVER_TEST;
function ListaMedicos(props) {
  const pic = getRandomInt(0, 999);
  const navigate = useNavigate();
  const { user } = useContext(AccountContext);
  const { id_contrato, titular } = user;
  const state = useLocation();
  const [isLoading, setLoading] = useState(true);
  const typeList = props.typeList;
  const especialidade = props.especialidade;

  const isAndroid = user.device === 'android' ? true : false;

  var mapUriPrefix = 'https://maps.apple.com/?q=';
  if (isAndroid) mapUriPrefix = 'https://maps.google.com/?q=';
  const {
    medicos,
    loadingMedicos,
    fetchData,
    searchContext,
    lastSearch,
    profession,
    professionList,
    setProfession,
    setAvaliacoesAtualizadas,
    avaliacoes_atualizadas,
  } = useContext(SearchContext);
  const { webviewParams, toastInadimplente } = useContext(AccountContext);
  const [medicos2, setMedicos2] = useState(medicos);
  const [fetchMore, setFetchMore] = useState(false);
  const disclousureSemMedicos = useDisclosure();
  const [openDrawerProfissoes, setDrawerProfissoes] = useState(false);
  const [searchProfissao, setSearchProfissao] = useState('');
  const [selectedProfissao, setSelectedProfissao] = useState(null);
  const sexo = user?.loggedIn ? (user.sexo === 'M' || user.sexo === 'm' ? 'M' : user.sexo === 'F' || user.sexo === 'f' ? 'F' : '') : null;

  useEffect(() => {
    if (!selectedProfissao) {
      setSelectedProfissao({ id: 'todos', nome: 'Todos' });
    }
  }, []);

  useEffect(() => {
    setMedicos2(medicos);
  }, [medicos]);

  const dataAtual = new Date();

  let data_parcela = '';
  if (user.qntdeParcelas?.countParcelas > 0) {
    data_parcela = user?.qntdeParcelas?.datasParcelas !== null ? new Date(user?.qntdeParcelas?.datasParcelas[0]) : null;
    if (data_parcela !== null) {
      const dia = user?.qntdeParcelas?.forma_pagamento === 13 ? 60 : 0;
      data_parcela.setDate(data_parcela?.getDate() + dia);
    }
  }

  useEffect(() => {
    if (user.qntdeParcelas?.countParcelas && user.qntdeParcelas?.countParcelas > 0 && dataAtual >= data_parcela) {
      toastInadimplente(user.id_forma_pagamento, user.qntdeParcelas);
    }
  }, []);

  useEffect(() => {
    setLoading(false);
    var busyStack = false;
    var page = 1;

    const handleScroll = async () => {
      let urlPart;
      if (user.coords != null) {
        urlPart = `&lat=${user.coords.latitudeAtual}&lng=${user.coords.longitudeAtual}`;
      } else {
        if (
          user.coordenadas_cidade &&
          user.coordenadas_cidade.latitude !== null &&
          user.coordenadas_cidade.latitude !== 'null' &&
          user.coordenadas_cidade.latitude !== undefined &&
          user.coordenadas_cidade.latitude !== 'undefined'
        ) {
          urlPart = `&lat=${user.coordenadas_cidade.latitude}&lng=${user.coordenadas_cidade.longitude}`;
        } else {
          urlPart = `&city=${user.cidade ? user.cidade : 'FORTALEZA'}`;
        }
      }

      if (window.innerHeight + window.scrollY + 10 > document.body.offsetHeight && busyStack === false) {
        setFetchMore(true);
        busyStack = true;
        let url =
          ENDPOINT + `/schedule/searchMedicos?page=${page + 1}&limit=${10}${urlPart}&profession=${profession}&typeList=${typeList}&sexo=${sexo}`;
        if (searchContext === 'search')
          url = ENDPOINT + `/schedule/searchMedicos?text=${lastSearch}&page=${page + 1}&limit=${10}${urlPart}&typeList=${typeList}&sexo=${sexo}`;
        let data = await fetchData(url);
        let lastPage = data.length === 0;
        if (!lastPage) busyStack = false;
        setMedicos2((prev) => [...prev, ...data]);
        page++;
        setFetchMore(false);
        return;
      }
    };

    window.removeEventListener('scroll', handleScroll);
    window.addEventListener('scroll', handleScroll);

    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, [profession, searchContext, lastSearch, user]);
  const assinante = userIsSubscriber(user);
  const clientePendente = user?.loggedIn && user?.qntdeParcelas?.countParcelas && user?.qntdeParcelas?.countParcelas > 0 && dataAtual >= data_parcela;
  useEffect(() => {
    if (!clientePendente) {
      toastInadimplente(user.id_forma_pagamento, user.qntdeParcelas);
    }
  }, [assinante, clientePendente]);
  const [modalAviso, setModalAviso] = useState(false);
  const [elementoClicado, setElementoClicado] = useState(false);

  let filteredProfessions = professionList;

  const tempDuplicate = [];

  const listaUnicaMedicos = [];

  medicos2.forEach((rest) => {
    const especialidades = rest?.dados?.especialidades || [];

    if (especialidades.length === 0) {
      listaUnicaMedicos.push(rest);
      return;
    }

    especialidades.forEach((e, key) => {
      const dados = {
        ...rest.dados,
        especialidades: [e],
        especialidade: e?.especialidade,
        ambulatorio_tipo_consulta_id: e?.id,
      };

      const horarios =
        rest?.horarios?.map((h) => ({
          ...h,
          procedimentos: h?.procedimentos?.filter((p) => p?.ambulatorio_tipo_consulta_id === e?.id) || [],
        })) || [];

      const medicoFormatado = {
        ...rest,
        ambulatorio_tipo_consulta_list: [e?.id],
        dados,
        horarios,
      };

      if (key === 0) {
        listaUnicaMedicos.push(medicoFormatado);
      } else {
        tempDuplicate.push(medicoFormatado);
      }
    });
  });

  const resultadoFinal = [...listaUnicaMedicos, ...tempDuplicate];

  let filteredMedicos = [...listaUnicaMedicos, ...tempDuplicate].sort((a, b) => {
    return a.dados.nome.localeCompare(b.dados.nome);
  });

  if (selectedProfissao && selectedProfissao.id !== 'todos') {
    filteredMedicos = filteredMedicos.filter((medico) => String(medico?.dados?.ambulatorio_tipo_consulta_id) === String(selectedProfissao.id));
  }

  const tratarNome = (nomeCompleto) => {
    if (!nomeCompleto) return '';

    const capitalizar = (palavra) => palavra.charAt(0).toUpperCase() + palavra.slice(1).toLowerCase();

    const partes = nomeCompleto.trim().split(/\s+/).filter(Boolean);

    if (partes.length === 0) return '';

    const primeiroNome = capitalizar(partes[0]);

    if (partes.length === 1) return primeiroNome;

    const segundoNome = capitalizar(partes[1]);

    return `${primeiroNome} ${segundoNome}`;
  };

  const AvaliacaoEstrela = ({ avaliacao }) => {
    const [avaliacaoMedia, setAvaliacaoMedia] = useState('5.0');
    const [isLoading, setIsLoading] = useState(false);

    useEffect(() => {
      const formatarAvaliacao = (media) => {
        const valor = Math.floor(media * 10) / 10;
        return valor.toFixed(1);
      };

      if (avaliacao && avaliacao.avaliacao_media) {
        const media = avaliacao.avaliacao_media >= 1 ? avaliacao.avaliacao_media : 5;
        setAvaliacaoMedia(formatarAvaliacao(media));
      } else {
        setAvaliacaoMedia('5.0');
      }
      setIsLoading(false);
    }, [avaliacao]);
    return (
      <chakra.span mt={-0.5}>
        <StarIcon color="orange" fontSize="1em" mt={-0.3} />
        <chakra.span fontSize="0.625em" color="orange" fontWeight={300} ml={1}>
          {avaliacaoMedia}
        </chakra.span>
      </chakra.span>
    );
  };

  const opcaoTodos = { id: 'todos', nome: 'Todos', descricao: 'Ver todos os profissionais disponíveis' };

  const profissoesSemTodos = filteredProfessions?.filter((prof) => prof?.nome?.toLowerCase() !== 'todos' && prof?.id !== 'todos') || [];

  const profissoesComTodos = [opcaoTodos, ...profissoesSemTodos];

  function normalizeString(str) {
    return str
      ? str
          .normalize('NFD')
          .replace(/[\u0300-\u036F]/g, '')
          .toLowerCase()
      : '';
  }

  const filteredProfessionsBySearch =
    profissoesComTodos?.filter((prof) => normalizeString(prof.nome).includes(normalizeString(searchProfissao))) || [];

  const handleSelectProfissao = (profissao) => {
    if (profissao.id === 'todos') {
      setSelectedProfissao({ id: 'todos', nome: 'Todos' });
    } else {
      setSelectedProfissao({ id: profissao.profissoes_id, nome: profissao.nome });
    }
    setDrawerProfissoes(false);
    setSearchProfissao('');
  };

  const drawerProfissioes = () => {
    return (
      <Drawer isOpen={openDrawerProfissoes} placement="bottom" onClose={() => setDrawerProfissoes(false)} blockScrollOnMount={false}>
        <DrawerOverlay bg="blackAlpha.300" />
        <DrawerContent borderTopRadius="24px" pb={4} w="100%" maxH="80vh" overflow="hidden" bg="white" boxShadow="xl">
          <Box w="40px" h="4px" bg="gray.300" borderRadius="full" mx="auto" mt={4} mb={2} />

          <DrawerHeader pb={2} pt={3}>
            <VStack spacing={3} align="stretch">
              <Heading size="md" color="gray.700" textAlign="center">
                Escolha a profissão
              </Heading>
              <InputGroup>
                <InputLeftElement pointerEvents="none">
                  <FiSearch color="gray.400" size="18px" />
                </InputLeftElement>
                <Input
                  placeholder="Pesquisar profissão..."
                  value={searchProfissao}
                  onChange={(e) => setSearchProfissao(e.target.value)}
                  borderRadius="xl"
                  bg="gray.50"
                  border="1px solid"
                  borderColor="gray.200"
                  _focus={{
                    borderColor: '#5AB2AE',
                    boxShadow: '0 0 0 1px #5AB2AE',
                    bg: 'white',
                  }}
                  _placeholder={{ color: 'gray.400' }}
                />
              </InputGroup>
            </VStack>
          </DrawerHeader>

          <Divider color="gray.100" />

          <DrawerBody p={0} pt={3}>
            <VStack spacing={2} w="100%" maxH="50vh" overflowY="auto" px={4} pb={5}>
              {filteredProfessionsBySearch.length === 0 ? (
                <VStack py={8} spacing={3}>
                  <Text color="gray.500" fontSize="md">
                    Nenhuma profissão encontrada
                  </Text>
                  <Text color="gray.400" fontSize="sm">
                    Tente pesquisar com outros termos
                  </Text>
                </VStack>
              ) : (
                filteredProfessionsBySearch.map((item) => {
                  const isSelected = selectedProfissao?.id === item.id;
                  const isTodosOption = item.id === 'todos';
                  return (
                    <Flex
                      key={item?.id}
                      w="100%"
                      align="center"
                      justify="space-between"
                      p={4}
                      borderRadius="xl"
                      cursor="pointer"
                      transition="all 0.2s ease"
                      bg={isSelected ? '#5AB2AE' : 'white'}
                      border="1px solid"
                      borderColor={isSelected ? '#5AB2AE' : 'gray.200'}
                      _hover={{
                        bg: isSelected ? '#4A9B97' : 'white',
                        borderColor: isSelected ? '#4A9B97' : '#5AB2AE',
                        transform: 'translateY(-1px)',
                        boxShadow: 'md',
                      }}
                      _active={{
                        transform: 'translateY(0px)',
                      }}
                      onClick={() => handleSelectProfissao(item)}
                    >
                      <VStack align="flex-start" spacing={1} flex={1}>
                        <HStack spacing={2}>
                          {isTodosOption && <Box w={3} h={3} bg={isSelected ? 'white' : '#5AB2AE'} borderRadius="full" />}
                          <Text
                            fontSize="md"
                            fontWeight={isTodosOption ? 'bold' : 'semibold'}
                            color={isSelected ? 'white' : 'gray.700'}
                            noOfLines={1}
                          >
                            {tratarNome(item.nome)}
                          </Text>
                        </HStack>
                      </VStack>

                      <HStack spacing={2}>
                        {item.count_medicos && !isTodosOption && (
                          <Badge colorScheme={isSelected ? 'whiteAlpha' : 'teal'} variant={isSelected ? 'solid' : 'subtle'} borderRadius="lg" px={2}>
                            {item.count_medicos} {item.count_medicos === 1 ? 'médico' : 'médicos'}
                          </Badge>
                        )}

                        {isSelected && <Icon as={FiCheck} color="white" boxSize={5} />}
                      </HStack>
                    </Flex>
                  );
                })
              )}
            </VStack>
          </DrawerBody>
        </DrawerContent>
      </Drawer>
    );
  };

  const toCamelCase = (text = '') =>
    text
      .toLowerCase()
      .split(' ')
      .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
      .join(' ');

  const useMedicos = useMemo(() => {
    return filteredMedicos.map((medico, index) => {
      const arrName = medico.dados.nome.split(' ');
      const preposicoes = ['das', 'dos', 'des', 'da', 'do', 'de'];
      const nomeMedico = Array.isArray(arrName)
        ? arrName.filter((name, index) => index <= 1 && preposicoes.includes(name.toLowerCase()) === false).join(' ')
        : '';

      if (!medico.horarios) {
        medico.horarios = [
          {
            AVA_DATE: '0',
            procedimentos: [
              {
                id: 0,
                nome: '',
                valor: '0',
                convenio_id: 0,
                procedimento_particular: [
                  {
                    particular_id: 0,
                    particular_valor: '0',
                  },
                ],
              },
            ],
          },
        ];
      }

      const isButtonDisabled = !medico.horarios || !medico.horarios[0]?.procedimentos || medico.horarios[0]?.AVA_DATE === '0';

      // const event = new Date(medico.horarios[0]?.AVA_DATE.split('/').reverse().join('-') + 'T08:00:00');

      const urlMapa = `${mapUriPrefix}${medico.dados.logradouro}, ${medico.dados.numero}, ${medico.dados.bairro}, ${medico.dados.municipio}, Ceará`;
      // const options = { weekday: 'long', month: 'long', day: 'numeric' };
      let titulo = '';
      // let promocao = '';
      if (medico.dados.sexo === 'M') {
        titulo = 'Dr. ';
      } else if (medico.dados.sexo === 'F') {
        titulo = 'Dra. ';
      }
      const avaliacao = avaliacoes_atualizadas.find((a) => a.operador_id === medico.dados.medico_id) || {
        operador_id: medico.dados.medico_id,
        avaliacao_media: medico.dados.avaliacao_media || 5,
      };

      const proxima_data = medico.horarios?.[0]?.AVA_DATE;

      let menorValorEncontrado = null;

      medico.horarios?.forEach((horario) => {
        horario.procedimentos?.forEach((p) => {
          let valorParaComparar = 0;

          if (assinante) {
            valorParaComparar = Number(p.valor || 0);
          } else {
            const particular = Array.isArray(p.procedimento_particular) ? p.procedimento_particular[0] : p.procedimento_particular;

            valorParaComparar = Number(particular?.valor || particular?.particular_valor || 0);
          }

          if (valorParaComparar > 0) {
            if (menorValorEncontrado === null || valorParaComparar < menorValorEncontrado) {
              menorValorEncontrado = valorParaComparar;
            }
          }
        });
      });

      const valor = menorValorEncontrado || 0;
      const semHorarioNaoAssinante = !assinante && valor === 0;

      return (
        <>
          <Flex
            align="center"
            borderRadius="2em"
            p={3}
            mb={2}
            boxShadow="lg"
            w={{ base: '100%', md: '650px' }}
            maxW="100vw"
            flexWrap="wrap"
            overflow="hidden"
          >
            <Avatar
              alt={tratarNome(medico?.dados?.nome || medico?.nome)}
              boxSize="56px"
              borderRadius="lg"
              mr={{ base: 0, sm: 4 }}
              mb={{ base: 3, sm: 0 }}
              id={medico.dados.medico_id}
              name={tratarNome(medico?.dados?.nome || medico?.nome)}
              src={
                medico?.foto ||
                medico?.dados?.foto ||
                `${process.env.REACT_APP_URL_PROFILEPICS_OPERADOR}/${medico?.dados?.medico}/foto_profissional.png`
              }
              mt={2}
              fontSize="0.75rem"
              color="white"
              bg="#5AB2AE"
              onClick={() => navigate('/empresa/medico/curriculo', { state: { medico, avaliacao: avaliacao } })}
            />

            <Box flex="1" minW={{ base: '100%', sm: '220px' }} pr={{ base: 0, sm: 2 }}>
              <HStack w="100%" justify="space-between" align="center" spacing={2}>
                <Text fontWeight="bold" fontSize="md" color="#616161" isTruncated maxW={{ base: '110px', sm: '180px' }}>
                  {titulo} {tratarNome(medico?.dados?.nome || medico?.nome)}
                </Text>

                <AvaliacaoEstrela avaliacao={avaliacao} />
              </HStack>

              <Text fontSize="sm" color="#4A4A4A" noOfLines={2} maxW="220px" wordBreak="break-word">
                {tratarNome(medico?.dados?.especialidade || medico?.especialidade)}
              </Text>
              <Text fontSize="0.8em" color="#818181" noOfLines={2}>
                {medico?.dados?.conselho && medico?.dados?.conselho}
                {medico?.dados?.conselho && medico?.dados?.rqe && ' '}
                {medico?.dados?.rqe && medico?.dados?.rqe}
              </Text>
            </Box>

            <Flex mt={4} w="100%" align="flex-start" flexDirection="column">
              <HStack mb={1}>
                <Image src={empresa} boxSize="16px" />
                <chakra.p fontSize="lg" color="#757575" fontWeight="bold" wordBreak="break-word">
                  {toCamelCase(medico.dados.empresa)}
                </chakra.p>
              </HStack>

              <chakra.p fontSize="sm" color="#9E9E9E" textDecor="underline" wordBreak="break-word">
                <Icon as={RiMapPin2Fill} mr={1} color="red" cursor="pointer" onClick={() => window.open(urlMapa, '_blank')} />
                {toCamelCase(medico.dados.logradouro)},{` ${toCamelCase(medico.dados.numero)} - `}
                {toCamelCase(medico.dados.bairro)} - {toCamelCase(medico.dados.municipio)}
              </chakra.p>
            </Flex>
            {semHorarioNaoAssinante ? (
              <>
                <Box p={4} mt={4} w="100%" borderRadius="lg" bg="gray.50" border="1px solid" borderColor="gray.200" textAlign="center">
                  <Text fontSize="sm" fontWeight="medium" color="gray.700" mb={1}>
                    Horários disponíveis apenas para assinantes
                  </Text>

                  <Text fontSize="sm" color="gray.500" mb={3}>
                    Assine para visualizar a agenda completa e agendar consultas com este profissional.
                  </Text>
                  <Button
                    size="sm"
                    variant="outline"
                    colorScheme="teal"
                    borderRadius="md"
                    px={5}
                    _hover={{
                      bg: 'teal.50',
                    }}
                    onClick={() => {
                      navigate('/cadastro/plano');
                    }}
                  >
                    Assine e agende sua consulta
                  </Button>
                </Box>
              </>
            ) : (
              <>
                <Flex mt={4} w="100%" justify="space-between" align="center" gap={4} direction={{ base: 'column', sm: 'row' }}>
                  <Flex direction="column" align="flex-start" gap={1}>
                    <p
                      style={{
                        color: '#9E9E9E',
                        fontSize: '0.7em',
                      }}
                    >
                      Consulta por
                    </p>

                    <Text fontSize="md" color="#757575" fontWeight="bold" whiteSpace="nowrap">
                      {(() => {
                        return new Intl.NumberFormat('pt-BR', {
                          style: 'currency',
                          currency: 'BRL',
                        }).format(valor);
                      })()}
                    </Text>
                  </Flex>

                  <Button
                    fontWeight="normal"
                    bg="#5AB2AE"
                    borderRadius="2em"
                    px={6}
                    py={2}
                    w={{ base: '100%', sm: '180px', md: '220px' }}
                    minW={{ base: '100%', sm: '200px', md: '240px' }}
                    flexShrink={0}
                    fontSize="sm"
                    color="white"
                    whiteSpace="nowrap"
                    leftIcon={<Icon as={IoMdCalendar} boxSize={4} color="white" />}
                    onClick={() => {
                      if (!medico.horarios[0]?.procedimentos && !isButtonDisabled) {
                        navigate('/atendimento/agendamento', {
                          state: {
                            medico,
                            startNum: 0,
                            st: 0,
                            defaultDateTime: null,
                            procedimentoId: medico.horarios[0].ACTIVITY_LID,
                            procedimento: medico.horarios[0].ACTIVITY_NAME,
                            price: medico.horarios[0].PRICE,
                            avaliacao: avaliacoes_atualizadas,
                          },
                        });
                      } else {
                        if (!isButtonDisabled) {
                          navigate('/atendimento/agendamento', {
                            state: {
                              medico,
                              startNum: 0,
                              st: 0,
                              defaultDateTime: null,
                              procedimentoId: medico.horarios[0]?.procedimentos[0].id,
                              procedimento: medico.horarios[0]?.procedimentos[0].nome,
                              price: medico.horarios[0]?.procedimentos[0].valor,
                              procedimentoParticular: medico.horarios?.[0]?.procedimentos?.[0]?.procedimento_particular?.particular_id ?? null,
                              valorParticular: medico.horarios?.[0]?.procedimentos?.[0]?.procedimento_particular?.valor ?? null,
                              restricao_sexo: medico.horarios[0]?.procedimentos[0].restricao_sexo,
                              avaliacao: avaliacoes_atualizadas,
                            },
                          });
                        } else if (!isButtonDisabled) {
                          navigate('/atendimento/escolha-procedimento', {
                            state: {
                              medico,
                              startNum: 0,
                              st: 0,
                              defaultDateTime: null,
                              avaliacao: avaliacoes_atualizadas,
                            },
                          });
                        }
                      }
                    }}
                  >
                    <Box w="100%" display="flex" alignItems="center" justifyContent="center" mr={4}>
                      <Text fontWeight="semibold" fontSize="0.9em" color="white" mr={2}>
                        Próxima data:
                      </Text>
                      {!proxima_data ? (
                        <Spinner size="sm" ml={2} />
                      ) : (
                        <Text fontWeight="bold" fontSize="0.9em" color="white">
                          {(() => {
                            const d = new Date(proxima_data.split('/').reverse().join('-') + 'T08:00:00');
                            return `${String(d.getDate()).padStart(2, '0')}/${String(d.getMonth() + 1).padStart(2, '0')}/${String(d.getFullYear()).slice(-2)}`;
                          })()}
                        </Text>
                      )}
                    </Box>
                  </Button>
                </Flex>
              </>
            )}
          </Flex>
        </>
      );
    });
  }, [filteredMedicos, avaliacoes_atualizadas, mapUriPrefix, pic]);

  return (
    <>
      <VStack w={'100%'} mb={10}>
        <Box mt={5} justifyContent="center" w={'100%'}>
          <Searchbox placeholder="Pesquise por profissionais de saúde" />
        </Box>
        {typeList !== 'Dentistas' && (
          <>
            <Box w="100%" px={4} py={5} bg="white" borderRadius="xl" mx={2} boxShadow="sm" border="1px solid" borderColor="gray.100">
              <VStack spacing={4} w="100%" alignItems="flex-start">
                <SkeletonText isLoaded={!loadingMedicos} noOfLines={1} w="100%">
                  <VStack spacing={2} alignItems="flex-start" w="100%">
                    <Text color="#4A4A4A" fontWeight="semibold" fontSize="md">
                      Filtre pela especialidade desejada
                    </Text>
                    <Text color="#9E9E9E" fontSize="sm">
                      Encontre rapidamente o profissional de saúde que você precisa
                    </Text>
                  </VStack>
                </SkeletonText>

                <Skeleton isLoaded={!loadingMedicos} w="100%" h="52px" borderRadius="xl">
                  <Flex
                    name="especialistas"
                    borderRadius="xl"
                    textAlign="left"
                    fontWeight="medium"
                    bg="gray.50"
                    border="2px solid"
                    borderColor="gray.200"
                    h="52px"
                    w="100%"
                    alignItems="center"
                    px={4}
                    cursor="pointer"
                    position="relative"
                    transition="all 0.3s ease"
                    _focus={{
                      borderColor: '#5AB2AE',
                      boxShadow: '0 0 0 3px rgba(90, 178, 174, 0.1)',
                    }}
                    _hover={{
                      borderColor: '#5AB2AE',
                      bg: 'white',
                      transform: 'translateY(-1px)',
                      boxShadow: 'md',
                    }}
                    _active={{
                      transform: 'translateY(0px)',
                      boxShadow: 'sm',
                    }}
                    onClick={() => setDrawerProfissoes(true)}
                    justify="space-between"
                  >
                    <HStack spacing={3} flex={1}>
                      <Box w={3} h={3} bg={selectedProfissao?.id !== 'todos' ? '#5AB2AE' : 'gray.400'} borderRadius="full" flexShrink={0} />
                      <Text color={selectedProfissao ? 'gray.700' : 'gray.500'} fontSize="md" fontWeight="medium" isTruncated>
                        {selectedProfissao ? selectedProfissao.nome : 'Selecione uma profissão'}
                      </Text>
                    </HStack>

                    <Box
                      w={8}
                      h={8}
                      bg="gray.100"
                      borderRadius="lg"
                      display="flex"
                      alignItems="center"
                      justifyContent="center"
                      flexShrink={0}
                      transition="all 0.2s ease"
                      _groupHover={{ bg: '#5AB2AE', color: 'white' }}
                    >
                      <Icon as={FiSearch} color="gray.500" boxSize={4} />
                    </Box>
                  </Flex>
                </Skeleton>
              </VStack>
            </Box>
          </>
        )}
        {openDrawerProfissoes && drawerProfissioes()}
        {!loadingMedicos && medicos2.length > 0 && (
          <>
            {medicos2 && useMedicos} {fetchMore && <DotsLoading />}
          </>
        )}
        {(loadingMedicos || isLoading) && (
          <VStack w="100%" maxW="320px" m="auto" justify="center" align="center" spacing={3} py={6}>
            <Loading />
          </VStack>
        )}

        {!loadingMedicos && !isLoading && medicos2.length === 0 && (
          <VStack w="100%" maxW="320px" m="auto" justify="center" align="center" spacing={3} py={6}>
            <Image src={VishMedicos} boxSize="96px" opacity={0.9} />

            <Heading fontSize="lg" textAlign="center" color="gray.700" fontWeight="semibold">
              Ops...
            </Heading>

            <Text fontSize="md" textAlign="center" color="gray.600" lineHeight="1.4">
              Nenhum <strong>{typeList === 'Medicos' ? 'médico' : typeList === 'Dentistas' ? 'dentista' : 'profissional de saúde'}</strong> está
              disponível no momento.
            </Text>

            <Text fontSize="sm" textAlign="center" color="gray.500">
              Tente novamente mais tarde.
            </Text>
          </VStack>
        )}
      </VStack>
    </>
  );
}

export default React.memo(ListaMedicos);
